import React from "react";
import {Route, Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {Constants} from "../utils";

const RouteAuth = (props) => {
  const token = localStorage.getItem("token");

  // Si no hay token en LocalStorage, o el usuario en Redux está marcado como inactivo
  if (!token || !props.user || props.user.status === Constants.INACTIVE) {
    return <Redirect to="/login" />;
  }

  return <Route {...props} />;
};

export default connect((state) => {
  return {
    user: state.user,
  };
})(RouteAuth);
